import {
  DownloadRounded,
  LockRounded,
  PersonRounded,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { FormEvent, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../components/logo";
import { ViewModelLogin } from "../viewmodel/viewmodel-login";

function LoginPage() {
  const viewModel = ViewModelLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await viewModel.handleLogin(email, password);
    } catch {
      // a mensagem de erro já é mostrada pelo viewmodel
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        bgcolor: "#fff",
        p: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{
          width: "100%",
          maxWidth: 400,
          p: { xs: 3, sm: 4 },
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "16px",
          bgcolor: "#fff",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", mb: 4 }}>
          <Box sx={{ mb: 2 }}>
            <Logo size={56} />
          </Box>
          <Typography variant="h5" component="h1">
            Iniciar sessão
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Aceda ao painel do Aprende+
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            autoComplete="email"
            inputProps={{ inputMode: "email" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonRounded fontSize="small" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="Senha"
            type={showPassword ? "text" : "password"}
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockRounded fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
                    onClick={() => setShowPassword((v) => !v)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Link
            component={RouterLink}
            to="/recuperar-senha"
            variant="body2"
            underline="hover"
            sx={{ alignSelf: "flex-end", mt: -1 }}
          >
            Esqueceu a senha?
          </Link>

          {viewModel.dialog.message && (
            <Alert severity={viewModel.dialog.type === "error" ? "error" : "success"}>
              {viewModel.dialog.message}
            </Alert>
          )}

          <Button type="submit" variant="contained" size="large" fullWidth disabled={submitting}>
            {submitting ? <CircularProgress size={22} color="inherit" /> : "Entrar"}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            component="a"
            href="https://apiacad.moztaservicos.com/api/storage/download/AprendeMais.exe"
            startIcon={<DownloadRounded />}
          >
            Baixar AprendeMais para Windows
          </Button>

          <Button component={RouterLink} to="/" color="inherit" sx={{ color: "text.secondary" }}>
            ← Voltar ao jogo
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;
